"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _SpotIllustration = _interopRequireDefault(require("../../SpotIllustration"));
var Styled = _interopRequireWildcard(require("./SpotIllustrationSection.styles"));
var _messages = _interopRequireDefault(require("./messages"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var SpotIllustrationSection = function SpotIllustrationSection(_ref) {
  var name = _ref.name,
    alt = _ref.alt,
    finalStep = _ref.finalStep;
  var intl = (0, _reactIntl.useIntl)();
  return /*#__PURE__*/_react["default"].createElement(Styled.SpotIllustrationSectionWrapper, {
    item: true,
    xs: 12,
    md: 7
  }, finalStep ? /*#__PURE__*/_react["default"].createElement(Styled.SpotIllustrationAnimation, null, /*#__PURE__*/_react["default"].createElement(_SpotIllustration["default"], {
    name: "scenic-spots-celebrate",
    size: {
      mobile: 'medium',
      desktop: 'large'
    },
    alt: intl.formatMessage(_messages["default"].imageAlt)
  })) : name && /*#__PURE__*/_react["default"].createElement(_SpotIllustration["default"], {
    name: name,
    size: {
      mobile: 'medium',
      desktop: 'large'
    },
    alt: alt
  }));
};
SpotIllustrationSection.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  finalStep: _propTypes["default"].bool
} : {};
var _default = exports["default"] = SpotIllustrationSection;